import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { settingApi } from "@api";
import { setAlert } from '@store/alerts.reducer';
import dayjs from 'dayjs';

const showErrorAlert = (dispatch) => {
    dispatch(setAlert({
      title: 'Ошибка',
      text: 'Не удалось загрузить время платформы',
      type: 'error'
    }));
};

export const fetchPlatformTime = createAsyncThunk(
  "platformTime/fetchPlatformTime",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await settingApi.getCurrentTime();
      if (response?.status !== 200 || response?.data?.status !== 'success' || !response?.data?.data) {
        showErrorAlert(dispatch)
        return rejectWithValue('Ошибка сервера: неверный статус ответа');
      }
      return response.data.data
    } 
    catch (error) {
        showErrorAlert(dispatch)
        return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  platformTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
  status: "idle",
  error: null,
};

const platformTimeSlice = createSlice({
  name: 'platformTime',
  initialState,
  reducers: {
    addOneMinute: (state) => {
      state.platformTime = dayjs(state.platformTime).add(1, 'minute').format('YYYY-MM-DD HH:mm:ss');
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlatformTime.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPlatformTime.fulfilled, (state, action) => {
        state.status = "success";
        state.platformTime = action.payload;
      })
      .addCase(fetchPlatformTime.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })
  },
});

export const { addOneMinute } = platformTimeSlice.actions;
export default platformTimeSlice.reducer;